import { isOidcAdminAuth } from './oidc/oidcConfig';
import { ADMIN_OIDC_TOKEN_EVENT, clearOidcTokens, getOidcAccessToken } from './oidc/oidcSession';

const STORAGE_KEY = 'evolveos_admin_console_jwt';

/**
 * The bearer the SPA sends to admin-api and the verification dashboards.
 *
 * - `VITE_ADMIN_AUTH=password` (default): admin-api HS256 JWT in localStorage (today).
 * - `VITE_ADMIN_AUTH=oidc`: the auth-server access token, held in memory only (oidcSession).
 */
export function getAdminConsoleToken(): string | null {
  if (isOidcAdminAuth()) return getOidcAccessToken();
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

export const ADMIN_CONSOLE_TOKEN_EVENT = 'evolveos:admin-console-token';

function emitTokenEvent(): void {
  try {
    window.dispatchEvent(new CustomEvent(ADMIN_CONSOLE_TOKEN_EVENT));
  } catch {
    /* ignore */
  }
}

// OIDC token changes (login, refresh, logout) are admin-console token changes too.
try {
  if (typeof window !== 'undefined') window.addEventListener(ADMIN_OIDC_TOKEN_EVENT, emitTokenEvent);
} catch {
  /* ignore */
}

/** Password mode only — OIDC tokens are never written to storage. */
export function setAdminConsoleToken(token: string): void {
  if (isOidcAdminAuth()) return;
  try {
    localStorage.setItem(STORAGE_KEY, token);
    emitTokenEvent();
  } catch {
    /* ignore quota / private mode */
  }
}

export function clearAdminConsoleToken(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
  if (isOidcAdminAuth()) {
    clearOidcTokens(); // emits via ADMIN_OIDC_TOKEN_EVENT
    return;
  }
  emitTokenEvent();
}
